import React, { ReactNode } from 'react';

// Material ui
import { Button as MaterialButton } from '@material-ui/core';

// Components
import Typography, { TypographyColor } from '@components/UI-KIT/Typography';
import Spinner from '@components/UI-KIT/Spinner';

// Styles
import './Button.scss';

interface Props {
    label?: string;
    labelColor?: TypographyColor;
    level?: 1 | 2 | 3 | 4 | 5;
    disabled?: boolean;
    icon?: ReactNode
    onClick: (_event?: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
    fullWidth?: boolean;
    loadingEvent?: boolean;
    errorColor?: boolean;
    warningColor?: boolean;
}

const Button: React.FC<Props> = ({
    level = 1,
    disabled = false,
    label,
    labelColor,
    icon,
    onClick,
    className,
    fullWidth = false,
    loadingEvent = false,
    errorColor = false,
    warningColor = false
}) => {
    const levels = [
        '', // No Button level 0
        'level-one',
        'level-two',
        'level-three',
        'level-four',
        'level-five'
    ];

    const style = () => {
        let styleObject = {};
        if(fullWidth) styleObject = { width: '100%' };

        return styleObject;
    };

    return (
        <MaterialButton
            disabled={disabled}
            style={style()}
            disableRipple
            className={`${icon ? 'ui-Button-with-icon ' : 'ui-Button-without-icon '}${levels[level]}${disabled ? ' disabled' : ''}${className ? ` ${className}` : ''}${errorColor ? ' error-color' : ''}${warningColor ? ' warning-color' : ''}`}
            onClick={onClick}
        >
            {icon && [ 3, 4 ].includes(level) ? icon : null}
            <Typography
                className="ui-Button-label"
                variant={level === 4 ? 'table-semibold' : 'h4'}
                color={
                    labelColor
                        ? labelColor
                        : level === 1
                            ? 'white'
                            : level === 4
                                ? 'secondary'
                                : 'primary'
                }
            >
                {label}
            </Typography>
            {icon && [ 1, 2 ].includes(level) ? icon : null}
            { (loadingEvent && disabled) && (
                <Spinner />
            )}
        </MaterialButton>
    );
};

export default Button;
